import { Service, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { SelectField, SelectFieldProps } from '@mews-commander/form';
import { isBookableService } from '@mews-commander/legacy-entities/src/ducks/servicesNew';
import { createOption } from '@mews-commander/ui';
import { LocalizedProperty } from '@mews/framework';
import { useTargetEnterpriseIdContext } from '../context';

const renderOptions = (services: Array<Service>) =>
    services.map((service) =>
        createOption({ value: service.id, label: <LocalizedProperty property={service.names} /> })
    );

const useBookableServicesSuspenseQuery = ({ enterpriseIds }: { enterpriseIds: Array<string> }) =>
    useRepositorySuspenseQuery(
        'services',
        'getAll',
        {
            enterpriseIds,
        },
        {
            select: (result) => result.services.filter(isBookableService),
        }
    );

export const ServiceIdField = (props: Pick<SelectFieldProps, 'label' | 'name'>) => {
    const targetEnterpriseId = useTargetEnterpriseIdContext();
    const { data: services, isFetching } = useBookableServicesSuspenseQuery({ enterpriseIds: [targetEnterpriseId] });

    return (
        <SelectField
            {...props}
            options={services ? renderOptions(services) : []}
            loader={isFetching}
            autoSelectOnlyOption
            required
        />
    );
};
